<template>
    <div>
        <v-tooltip v-bind="mergedProps" v-model="visible" content-class="custom-tooltip" :disabled="disabled">
            <template #activator="{ props }">
                <div v-bind="props">
                    <slot name="activator"></slot>
                </div>
            </template>
            <span class="tip">
                <div>
                    <strong>
                        <slot name="title"> </slot>
                    </strong>
                </div>
                <slot name="content"></slot>
            </span>
        </v-tooltip>
    </div>
</template>
<script>
export default {
    props: {
        tooltipProps: {
            type: Object,
            default: () => ({}),
        },
        disable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visible: false,
            defaultTooltipProps: {
                openDelay: 400,
            },
        };
    },
    computed: {
        mergedProps() {
            return this.mergeProps(this.defaultTooltipProps, this.tooltipProps);
        },
        disabled() {
            return !(this.$slots.title || this.$slots.content) || this.disable;
        },
    },
    watch: {
        visible(newVal) {
            //Hide tooltip @ any wheel scroll
            if (newVal) {
                document.addEventListener('wheel', this.closeTooltip);
            } else {
                document.removeEventListener('wheel', this.closeTooltip);
            }
            // on mobile auto-hide the tooltip afterm a delay
            if (this.$vuetify.display.mobile && newVal) {
                setTimeout(() => {
                    // console.log('autoclosing tooltip on mobile');
                    this.closeTooltip();
                }, 800);
            }
        },
    },
    methods: {
        mergeProps(defaults, overrides) {
            let merged = { ...defaults };
            for (let key in overrides) {
                if (overrides[key] !== undefined) {
                    merged[key] = overrides[key];
                }
            }
            return merged;
        },
        closeTooltip() {
            this.visible = false;
        },
    },
};
</script>
<style lang="scss">
// .v-tooltip__content {
//     color: black !important;
//     background-color: white !important;
//     opacity: 1 !important;
//     box-shadow: 0 -3px 10px -3px rgba(0, 0, 0, 0.1), 0 10px 20px -5px rgba(0, 0, 0, 0.3);
// }

.custom-tooltip {
    color: black !important;
    background-color: white !important;
    opacity: 1 !important;
    box-shadow: 0 -3px 10px -3px rgba(0, 0, 0, 0.1), 0 10px 20px -5px rgba(0, 0, 0, 0.3);
}
</style>
